import { render, staticRenderFns } from "./WasteDetailsGeneralData.vue?vue&type=template&id=0cdcf0da&"
import script from "./WasteDetailsGeneralData.vue?vue&type=script&lang=js&"
export * from "./WasteDetailsGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports